import { waitFor } from "../Helpers/pooler";

export function initializeComponents() {
    let jsSections = document.querySelectorAll('.shopify-section[class*="js"]');

    // Loop through sections with js classes and load them in
    jsSections.forEach(function (section) {
        for (let i = 0; i < section.classList.length; i++) {
            if (section.classList[i].substring(0, 2) === "js") {
                let componentName = section.classList[i];
                waitFor(
                    function () {
                        return LUC[this];
                    }.bind(componentName),
                    200,
                    Infinity
                ).then((component) => component.init(section));
            }
        }
    });
}
